import styles from "./MenuItem.module.scss";
import { Title2, Title3 } from "@components/new/Typo";
import cn from "classnames";
import { ReactNode } from "react";

interface IMenuItemProps {
  className?: string;
  title?: ReactNode;
  description?: ReactNode;
  leftDecoration?: ReactNode;
  rightDecoration?: ReactNode;
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  stretch?: boolean;
}

export const MenuItem = ({
  className,
  title,
  description,
  leftDecoration,
  rightDecoration,
  active,
  disabled,
  onClick,
  stretch,
}: IMenuItemProps) => {
  return (
    <div
      className={cn(
        className,
        styles.item,
        active && styles.active,
        disabled && styles.disabled,
        stretch && styles.stretch,
      )}
      onClick={onClick}
    >
      {leftDecoration}
      <div className={styles.title}>
        <Title2>{title}</Title2>
        {description ? (<Title3 color="grey-700">{description}</Title3>) : null}
      </div>
      {rightDecoration}
    </div>
  )
};
